<div class="modal-header">
  <h4 class="modal-title me-auto" id="modal-basic-title">Update available</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCancel()"
  ></button>
</div>
<div class="modal-body pb-0">
  <p>A newer version of FinQuery Fixed Assets is available.</p>
  @if (features.length) {
    <p>This update includes:</p>
    <ul>
      @for (feature of features; track feature) {
        <li>
          {{ feature }}
        </li>
      }
    </ul>
  }
  <p>Would you like to reload to get the latest version?</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline ms-2" (click)="onCancel()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary" (click)="onUpdate()">
    Update
  </button>
</div>
